<template>
  <b-card no-body class="mb-4 p-2 border-0 shadow">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <h5 class="p-2">
        <i class="fa fa-sitemap" />
        ÁRBOL DE UBICACIONES
      </h5>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <b-input-group>
              <b-form-input
                name="nombre"
                type="text"
                placeholder="Buscar..."
                v-model="filterText"
                class="text-uppercase"
              />
              <b-input-group-append>
                <b-button @click="limpiarFiltro" class="btn btn-default">
                  <i class="fa fa-eraser fa-lg" />
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col> </b-col>
      </b-row>
    </b-card-body>

    <el-tree
      class="filter-tree"
      :data="arbolUbicaciones"
      default-expand-all
      :filter-node-method="filterNode"
      ref="tree"
      @check-change="handleCheckChange"
    >
      <span   class="custom-tree-node" slot-scope="{ node }">
        <span class="m-0 p-0" >
          <b-badge :style="{ background: node.data.location_level.color}">{{ node.data.label }}</b-badge>
        </span>

        <el-tooltip v-if="validarPermisoComponente('empresa-editar-ubicaciones')" content="Inactivar" placement="bottom" effect="light">
          <el-button
            v-if="node.data.children.length === 0"
            type="text"
            size="medium"
            class="text-danger"
            @click="() => inactiveLocation(node.data.id)"
          >
            <i class="fa fa-trash ml-2 mr-1" />
          </el-button>
        </el-tooltip>
      </span>
    </el-tree>
  </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: "ubicaciones-empresa",

  data() {
    return {
      filterText: "",

      searchVal: "",
      filtro: "",
      ubicacion: "",
      newChild: {},
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  watch: {
    filterText(val) {
      let text = val.toString().toUpperCase();
      this.$refs.tree.filter(text);
    },
  },

  methods: {
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    limpiarFiltro() {
      this.filterText = "";
    },

    ...mapActions("location", ["inactiveLocation"]),
  },
  computed: {
    ...mapState("location", ["arbolUbicaciones"]),
  },
};
</script>

<style scoped>
.custom-tree-node {
  font-weight: bold;
  text-transform: uppercase;
}
.fa-trash {
  font-size: 20px;
}
.el-tree-node__expand-icon {
  cursor: pointer;
  color: #097b83;
  height: 30px;
  font-size: 25px;
  -webkit-transform: rotate(0);
  transform: rotate(0);
  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
}
</style>
